// src/components/EventDetail.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../lib/api'; // APIユーティリティのインポート
//import 'bootstrap/dist/css/bootstrap.min.css';

const EventDetail = () => {
    const { eventId } = useParams();
    const navigate = useNavigate();
    const [participants, setParticipants] = useState([]);
    const [nonParticipants, setNonParticipants] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchResults = async () => {
            try {
                const response = await api.get(`/events/${eventId}/results/`); // APIを通じてデータ取得
                const allResults = response.data;
                
                const participantsList = allResults.filter(r => r.is_participating);
                const nonParticipantsList = allResults.filter(r => !r.is_participating);

                setParticipants(participantsList);
                setNonParticipants(nonParticipantsList);
                setLoading(false);
            } catch (error) {
                console.error('Failed to fetch results:', error);
                setLoading(false);
            }
        };
        fetchResults();
    }, [eventId]);

    if (loading) {
        return <div className="text-center mt-5">読み込み中...</div>;
    }

    return (
        <div className="container mt-4">
            <h2 className="mb-4 text-center">結果</h2>

            <button className="btn-back adm-btn" onClick={() => navigate(-1)}>戻る</button>

            <div className="row">
                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-header bg-success text-white">
                            <h5>参加 ({participants.length} 人)</h5>
                        </div>
                        <ul className="list-group list-group-flush">
                            {participants.length === 0 ? (
                                <li className="list-group-item">参加者はいません。</li>
                            ) : (
                                participants.map(p => (
                                    <li key={p.employeeId} className="list-group-item">
                                        {p.employeeId} - {p.employeeName}
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card">
                        <div className="card-header bg-danger text-white">
                            <h5>参加しない ({nonParticipants.length} 人)</h5>
                        </div>
                        <ul className="list-group list-group-flush">
                            {nonParticipants.length === 0 ? (
                                <li className="list-group-item">全員参加しています。</li>
                            ) : (
                                nonParticipants.map(p => (
                                    <li key={p.employeeId} className="list-group-item">
                                        {p.employeeId} - {p.employeeName} <br/>
                                        <small className="text-muted">理由: {p.reason || 'なし'}</small>
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventDetail;